import { create } from "zustand";

export interface ISmsVerificationInfo {
    phone: string;
    code: string;
}

interface SmsVerificationInfoStore {
    smsVerificationInfo: ISmsVerificationInfo;
    partnerCode: string;
    setSmsVerificationInfo: (smsVerificationInfo: ISmsVerificationInfo) => void;
    setPartnerCode: (partnerCode: string) => void;
}

export const useSmsVerificationInfoStore = create<SmsVerificationInfoStore>((set) => ({
    smsVerificationInfo: {
        phone: "",
        code: "",
    },
    partnerCode: "",
    setSmsVerificationInfo: (smsVerificationInfo) => set({ smsVerificationInfo }),
    setPartnerCode: (partnerCode) => set({ partnerCode }),
}));
